import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import common from 'constants/common';
import logo from 'assets/img/logo.svg';

const ManualInteractionTimeItem = ({ id, manualInteractionTime }) => {
  const { comment, timeInMinutes, date, author } = manualInteractionTime;
  return (
    <tr>
      <td className="col-1 text-center">{id}</td>
      <td className="col-8 comment">
        <strong>Manual Clinical Note</strong>
        <span className="comment__msg">Comment: {comment}</span>
        <span>Time added: {timeInMinutes}</span>
        <span>By: {author}</span>
      </td>
      <td className="col-3 info">
        <img src={logo} alt="Manual interaction time comment logo" />
        <span>
          {date ? format(new Date(date), common.dateFormats.dateAndTime) : ''}
        </span>
      </td>
    </tr>
  );
};
ManualInteractionTimeItem.propTypes = {
  manualInteractionTime: PropTypes.shape().isRequired,
  id: PropTypes.number,
};

export default ManualInteractionTimeItem;
